import React from 'react'

export const Card = ({ title, children, footer, className = '' }) => (
  <div className={`rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-4 shadow-sm transition-colors ${className}`}>
    {title && <h3 className="font-semibold mb-3 text-slate-900 dark:text-slate-100">{title}</h3>}
    <div>{children}</div>
    {footer && <div className="pt-3">{footer}</div>}
  </div>
)

